import config from 'config';
import queryString from 'query-string'
import debug from 'lib/common/debug';
import has from 'lodash/has';
import includes from 'lodash/includes';

let inDebugMode = debug.inDebugMode();
let parsedQuery = queryString.parse(window.location.search);

export function isEnabled(featureName, features) {
    features = features || config.features;
    let enabled = (
        has(config, 'features') &&
        has(features, featureName) &&
        has(features, [featureName, 'enabled']) &&
        features[featureName].enabled
    );

    if (inDebugMode) {
        let featureOn = parsedQuery.feature_on;
        let featureOff = parsedQuery.feature_off;

        if (featureOn && includes(featureOn.split(','), featureName)) {
            return true;
        }

        if (featureOff && includes(featureOff.split(','), featureName)) {
            return false;
        }
    }

    return enabled;
}

export function logEnabledFeatures(features) {
    features = features || config.features;
    if (inDebugMode && console && 'groupCollapsed' in console) {
        console.groupCollapsed('[Features]');
        Object.keys(features).forEach(function(featureName) {
            console.info(`[Feature] ${featureName}`, isEnabled(featureName));
        });
        console.groupEnd();
    }
}

export function getOption(featureName, key, features) {
    features = features || config.features;
    if (
        isEnabled(featureName, features) &&
        has(features, [featureName, key])
    ) {
        return features[featureName][key];
    }
}

export default {
    isEnabled,
    logEnabledFeatures,
    getOption
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/common/features.js